module.exports = __webpack_public_path__ + "static/pic14-334cda0b8a7aea47a9576b4456c79730.png";